class DigitalProducts extends HTMLElement {
	getParentProductId() {
		return Number(this.dataset.parent);
	}

	getSelectedChildren() {
		return [...this.querySelectorAll('.digital-checkbox:checked')].map((input) => Number(input.value));
	}

	buildDigitalItems(quantity = 1) {
		const bundleId = crypto?.randomUUID?.() || `${Date.now()}-${Math.random()}`;
		const parentId = this.getParentProductId();
		const childrenIds = this.getSelectedChildren();
		const type = 'digital_bundle';

		const items = childrenIds.map((childId) => ({
			id: childId,
			quantity,
			properties: {
				[`_${type}_id`]: bundleId,
				[`_${type}_role`]: 'child',
				_parent_set: String(parentId),
			},
		}));

		return {
			items,
			mainItemProperties: {
				[`_${type}_id`]: bundleId,
				[`_${type}_role`]: 'parent',
			},
		};
	}
}

customElements.define('digital-products', DigitalProducts);
